<template>
  <div class="report-type-table-cell">
    {{formattedType}}
  </div>
</template>

<script>
import { REPORT_TYPES } from '@/constants/report';

export default {
  name: 'ReportTypeTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  computed: {
    formattedType() {
      if (this.item.type === REPORT_TYPES.CYBER_RISK) {
        return this.$t('reportsTable.type.cyber.risk');
      }
      if (this.item.type === REPORT_TYPES.CLOUD_COMPLIANCE) {
        return this.$t('reportsTable.type.cloud.compliance');
      }
      return this.$t('reportsTable.type.highlights');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.report-type-table-cell {
  max-height: rem(48);
  font-family: $font-family-regular;
  color: var(--text-primary);
  font-size: rem(14);
  letter-spacing: 0;
  line-height: rem(16);
  overflow: hidden;
  display: flex;
  align-items: center;
  margin-top: rem(5);
}
</style>
